import type { SVGProps } from "react";
export interface BugOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BugOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BugOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.875 22v-.114a4.12 4.12 0 0 1 2.902-3.939 7.6 7.6 0 0 1-.32-1.322H2a1.125 1.125 0 1 1 0-2.25h2.374v-1.396a4.13 4.13 0 0 1-2.96-3.17l-.018-.088-.016-.115a1.125 1.125 0 0 1 2.195-.439l.027.113.018.088c.097.483.375.89.754 1.16V10.5c0-1.042.213-2.036.592-2.943L1.205 3.795l-.078-.085A1.125 1.125 0 0 1 2.71 2.127l.085.078 19 19 .077.085a1.125 1.125 0 0 1-1.582 1.582l-.085-.076-2.379-2.379A7.6 7.6 0 0 1 12 23.125a7.62 7.62 0 0 1-6.158-3.127l-.263.062a1.875 1.875 0 0 0-1.454 1.826V22a1.126 1.126 0 0 1-2.25 0m11.25-1.243a5.37 5.37 0 0 0 3.1-1.941l-3.1-3.1zm-6.5-5.258a5.376 5.376 0 0 0 4.25 5.256v-7.289l-.34-.341h-3.91zm0-4.624h1.66L6.751 9.343c-.082.372-.128.76-.128 1.157v.375ZM22 14.375a1.125 1.125 0 1 1 0 2.25h-1.841a1.125 1.125 0 0 1 0-2.25h1.84Zm-4.625-.536v-.713h-.717a1.126 1.126 0 0 1 0-2.25h.717V10.5a5.377 5.377 0 0 0-7.639-4.878l-.22-.475v-.002l.22.477A1.124 1.124 0 0 1 8.46 3.818L7.6 2.675l-.064-.095a1.125 1.125 0 0 1 1.79-1.343l.073.088 1.254 1.67a7.7 7.7 0 0 1 2.694 0l1.253-1.67.074-.088A1.124 1.124 0 0 1 16.4 2.675l-.82 1.092a7.62 7.62 0 0 1 4.045 6.734v.026c.38-.27.658-.676.755-1.159l.017-.09a1.124 1.124 0 1 1 2.206.443l-.017.088a4.13 4.13 0 0 1-2.96 3.17v.86a1.125 1.125 0 0 1-2.25 0Z"
      />
    </svg>
  );
}
